import React from 'react';
import '../../styles/styles.css';

export default function srirangam() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Srirangam.png" alt="Sri Ranganatha Swamy" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Festival Date in Arunachalam<br />
    Vaikunta Ekadashi : 31st December, 2025<br />    
    <br />

  </strong></p>
  <p>SriRanganatha Official Seva Booking Site : <a href="https://srirangamranganathar.hrce.tn.gov.in/" target="_blank" rel="noopener noreferrer">
  riRanganatha Official Website
</a>
</p>  </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Tiruchirappalli District, Srirangam, Sri Ranganathaswamy Temple is the first and foremost among the 108 Vaishnava Divyadesams. The word `Koil` in Vaishnava parlance refers to Srirangam temple only. Srirangam Divyakshetram also called as `Bhooloka Vaikundam`, Bhoga Mandabam etc.Srirangam temple is the Swayamvyaktha kshetram. The Lord Ranganathaswamy is reclining position (Sayana kolam) facing South. This Divya desam, which was consecrated by the Azhwars, has become the headquarters of all Vaishnava shrines. Srirangam is situated on an island in the middle of the River Cauvery with seven turns and high walls covering an area of 156 acres. The tallest 236 feet tall 13-tier Rayagopuram in South Asia is located here. The temple has 52 sub-shrines and a golden Vimanam in the form of Pranavakaram, Om. Paravasudevar Thirumeni in Pranavakara Vimana is a special feature of this temple. The administrative system established by the Vaishnava Great Acharya Sri Ramanuja is still being followed in this temple. It is the proud shrine that houses the Thiruvaranga Perumal idol worshipped by Rama in the Treta Yuga.</p>
             </div>
        </div>
   <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Ranganatha Swamy Temple</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/Uv3IhTjRWdE?rel=0&modestbranding=1&showinfo=0"
                title="Ranganatha Swamy Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
</div>

)
}
